/**
 * Created by emilgrabowiec on 05.04.2016.
 */
jQuery(document).ready(() => {
  let reportTitlesIds = {};
  const lastSelectedReprint = localStorage.getItem('lastSelectedReprint');
  const lastSelectedWeek = localStorage.getItem('lastSelectedWeek');
  const licenseTypeSelect = $('.select-licenseType');
  const weekSelect = $('.time-report');

  $('select[name="num_services"]').select2({
    minimumResultsForSearch: Infinity
  });

  $('#reportModal').on('show.bs.modal', (e) => {
    const btn = $(e.relatedTarget);
    reportTitlesIds = {};

    $('#r-title').html(`"${btn.data('title')}"`);
    $('#r-subtitle').html(btn.data('subtitle'));
    $('#r-detail').html(btn.data('detail'));
    $('#r-tune').html(btn.data('tune'));
    reportTitlesIds[btn.data('id-item')] = btn.data('title');
  });

  $('#reportAllModal').on('show.bs.modal', (e) => {
    let titles = '';
    let titlesNumber = 0;
    reportTitlesIds = {};

    $('input.report-checkbox').each(function () {
      if ($(this).is(':checked')) {
        titlesNumber++;
        titles += `<h4 class="text-center">${$(this).data('title')}</h4>`;
        reportTitlesIds[$(this).data('id-item')] = $(this).data('title');
      }
    });

    if (titlesNumber == 0) {
      $('#report-titles-body').hide();
      $('#report-no-titles-body').show();
    } else {
      $('#titles-number').html(titlesNumber);
      $('#report-titles-list').html(titles);

      $('#report-titles-body').show();
      $('#report-no-titles-body').hide();
    }
  });

  $('#reportAllModal button[name="submit-view"], #reportAllModal button[name="submit-continue"], #reportModal button[name="submit-view"], #reportModal button[name="submit-continue"]').click(function () {
    const action = $(this).data('action');

    const parent = $(this).parent().parent().parent();

    const form = parent.find('form').first();
    const dataArr = form.serializeArray();

    parent.find('button').button('loading');

    localStorage.setItem('lastSelectedReprint', form.find('.select-licenseType').val());
    localStorage.setItem('lastSelectedWeek', form.find('.time-report').val());

    $.post(reportTitlesUrl, {
      dataArr,
      titles: reportTitlesIds
    }, (data) => {
      parent.find('button').button('reset');

      if (data.isError == 1) {
        alert(data.msgError);
      } else if (action == 'view') {
        /* redirect */
        window.location.href = data.link;
      } else {
        reportTitlesIds = {};
        $('.report-checkbox').attr('checked', false);
        $('#reportModal').modal('hide');
        $('#reportAllModal').modal('hide');
      }
    }, 'json');
  });

  if (lastSelectedReprint) {
    licenseTypeSelect.val(lastSelectedReprint).trigger('change').trigger('select2:select');
  }

  licenseTypeSelect.on('weeks-loaded', function () {
    if (!!lastSelectedWeek && lastSelectedReprint === $(this).val()) {
      $(this).closest('form').find('.time-report').val(lastSelectedWeek)
          .trigger('change');
    }
  });

  if (weekSelect.find(`option[value="${lastSelectedWeek}"]`).length > 0) {
    weekSelect.val(lastSelectedWeek).trigger('change');
  }
});
